import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WebPushService } from "../../service/web-push.service";
import { Dep } from '../../comm/class/auth';

@Component({
    selector: 'app-ctrl-sidebar',
    templateUrl: './ctrl-sidebar.component.html',
    styleUrls: ['./ctrl-sidebar.component.css']
})
export class CtrlSidebarComponent implements OnInit {

    constructor(
        public httpClient: HttpClient,
        private WebPushService: WebPushService,
    ) { }

    data:any = [];

    ngOnInit(): void {
        this.chackpermission();
        this.WebPushService.requestNotificationPermission(); // ✅ 直接呼叫 Web Push 權限請求
    }

    chackpermission(){
        const body = {act:1};
        const Storagedata = localStorage.getItem('usertoken_plus2'+Dep.user.id);
        if(Storagedata == null || Storagedata == "undefined"){
            this.httpClient.post<any>("/customer_service/checkperssion.php",body).subscribe(res => {

                const delayInMilliseconds = 600000; // 10 分鐘

                localStorage.setItem('usertoken_plus2'+Dep.user.id, res.data['allPerssion']);

                setTimeout(() => {
                    localStorage.removeItem('usertoken_plus2'+Dep.user.id);
                }, delayInMilliseconds);

            }, error => {
                console.log(error);
            });
        }
    }

}
